const selector = 'video.card-fonction__animation[data-feature-video-lazy]';
const initialized = new WeakSet();
const cardListeners = new WeakMap();

function hydrate(video) {
  if (video.dataset.featureVideoLoaded === 'true') return;

  for (const source of video.querySelectorAll('source[data-src]')) {
    source.src = source.dataset.src;
    source.removeAttribute('data-src');
  }

  video.dataset.featureVideoLoaded = 'true';
  video.load();
}

const visibilityObserver = 'IntersectionObserver' in window
  ? new IntersectionObserver((entries) => {
      for (const entry of entries) {
        const video = entry.target;
        if (entry.isIntersecting) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      }
    }, { threshold: 0.1 })
  : null;

const loadObserver = 'IntersectionObserver' in window
  ? new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        scanNearby(entry.target.closest('.cards'));
      }
    }, { rootMargin: '400px', threshold: 0 })
  : null;

function scanNearby(cards) {
  if (!cards) return;

  const margin = 400;
  for (const video of cards.querySelectorAll(selector)) {
    const rect = video.getBoundingClientRect();
    const isNearby = rect.right >= -margin
      && rect.left <= window.innerWidth + margin
      && rect.bottom >= -margin
      && rect.top <= window.innerHeight + margin;

    if (!isNearby || video.dataset.featureVideoLoaded === 'true') continue;
    hydrate(video);
    loadObserver?.unobserve(video);
    visibilityObserver?.observe(video);
  }
}

function observeCards(cards) {
  if (!cards) return;
  if (cardListeners.has(cards)) return;
  const listener = () => scanNearby(cards);
  cards.addEventListener('scroll', listener, { passive: true });
  cardListeners.set(cards, listener);
}

function videosWithin(root) {
  const videos = [...root.querySelectorAll(selector)];
  if (root instanceof Element && root.matches(selector)) videos.unshift(root);
  return videos;
}

function initialize(root = document) {
  for (const video of videosWithin(root)) {
    if (initialized.has(video)) continue;
    initialized.add(video);

    if (loadObserver) {
      loadObserver.observe(video);
      observeCards(video.closest('.cards'));
    } else {
      hydrate(video);
      video.play().catch(() => {});
    }
  }
}

function cleanup(root) {
  for (const video of videosWithin(root)) {
    video.pause();
    loadObserver?.unobserve(video);
    visibilityObserver?.unobserve(video);
    initialized.delete(video);
  }

  for (const cards of root.querySelectorAll('.cards')) {
    const listener = cardListeners.get(cards);
    if (!listener) continue;
    cards.removeEventListener('scroll', listener);
    cardListeners.delete(cards);
  }
}

initialize();
document.addEventListener('shopify:section:load', (event) => initialize(event.target));
document.addEventListener('shopify:section:unload', (event) => cleanup(event.target));
